<template>
	<div>
		<nav class="bd-header bg-white py-2 d-flex align-items-stretch border-bottom border-gray navbar navbar-expand-md navbar-light">
			<div class="container">
				<router-link :to="{path: '/'}" class="navbar-brand">
					<h1 class="d-flex align-items-center fs-4 mb-0">
						<img src="//iwstatic.g.bsrv.su/img/panel/bylex-logo.png" width="50" height="50" class="me-3" alt="byLex" />
						{{$t('logo-text')}}
					</h1>
				</router-link>
				<div class="me-auto"></div>
				<div class="d-flex" v-if="authModel.isAuth()">
					<div class="d-none d-sm-none d-md-block">
						<router-link :to="{path: '/settings'}" class="btn btn-link text-dark"><b>@{{authModel.userProfile.login}}</b></router-link>
						<router-link :to="{path: '/logout'}" class="btn btn-outline-secondary">{{$t('btn-logout')}}</router-link>
					</div>
					<router-link custom :to="{path: '/logout'}" v-slot="{href, route, navigate, isActive, isExactActive}">
						<button type="button" class="btn btn-outline-secondary btn-exit d-block d-sm-block d-md-none" @click="navigate">
							<svg class="svg-icon svg-icon_exit" width="16" height="16">
								<use xlink:href="/assets/images/icons-sprite.svg#exit"></use>
							</svg>
						</button>
					</router-link>
				</div>
			</div>
		</nav>
		<div class="d-flex align-items-center">
			<div class="container m-auto pt-5">
				<router-view/>
			</div>
		</div>
		<footer class="py-3">
			<div class="container text-center">
				<a
					href="#"
					class="btn btn-link text-muted"
					@click="$root.$i18n.locale = lang"
					v-for="(lang, i) in appModel.langs.filter(item => item != $root.$i18n.locale)"
					:key="`lang-${i}`"
				>
					<svg class="footer-links__icon footer-links__icon-ball" width="16" height="16">
						<use xlink:href="/assets/images/icons-sprite.svg#globus"></use>
					</svg>
					{{appModel.langsName[lang]}}
				</a>
				<router-link :to="{path: '/info/about'}" class="btn btn-link text-muted">{{$t('link-about')}}</router-link>
				<router-link :to="{path: '/feedback'}" class="btn btn-link text-muted">{{$t('link-feedback')}}</router-link>
				<router-link :to="{path: '/info/terms'}" class="btn btn-link text-muted" v-if="authModel.hasPermission('account.bylex.superadmin')">{{$t('link-info-terms')}}</router-link>
				<router-link :to="{path: '/info/privacy'}" class="btn btn-link text-muted" v-if="authModel.hasPermission('account.bylex.superadmin')">{{$t('link-info-privacy')}}</router-link>
			</div>
		</footer>
	</div>
</template>

<style lang="scss" scoped>
.svg-icon {
	padding: 0;
    font-size: 0;
    flex: none;
}
.svg-icon_exit {
    display: inline-block;
}
.btn-exit {
	padding-top: 2px;
}
.btn:hover .svg-icon_exit {
	fill: #fff;
}
.footer-links__icon {
	font-size: 0;
	line-height: 1;
	display: inline-block;
	vertical-align: middle;
}
.footer-links__icon-ball {
	margin-right: 5px;
	fill: currentColor;
}
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'byLex Account'});
	},
	data: () => ({
		
	}),
	methods: {},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	created(){
		this.$http.interceptors.response.use(undefined, function(err){
			return new Promise(function(resolve, reject){
				if(err.status === 401 && err.config && !err.config.__isRetryRequest){
					this.authModel.doLogout();
				}
				throw err;
			});
		});
	},
	components: {},
}
</script>